import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-网络连接流量",
  "use": "icon-网络连接流量-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-网络连接流量\">\n<circle cx=\"4.17938\" cy=\"3.92104\" r=\"2.37939\" stroke=\"white\" />\n<circle cx=\"4.17939\" cy=\"12.7588\" r=\"1.69956\" stroke=\"white\" />\n<circle cx=\"13.0171\" cy=\"8.67983\" r=\"1.01974\" stroke=\"white\" />\n<path d=\"M5.87892 12.1407L11.9973 8.6798M4.51927 11.0283L4.51927 6.26952M6.21883 4.94077L11.9973 8.38302\" stroke=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol